import {
    Printer,
    Cog,
    Zap,
    CircuitBoard,
    Bot,
    Layers,
    ArrowRight,
} from "lucide-react";
  import { Link } from "react-router-dom";

const machines = [
    {
        icon: Printer,
        title: "3D Printing",
        subtitle: "FDM · SLA · SLS · Metal",
        count: "140+ machines",
    },
    {
        icon: Cog,
        title: "CNC Machining",
        subtitle: "3, 4 & 5-axis · Turning",
        count: "120+ machines",
    },
    {
        icon: Zap,
        title: "Laser Cutting",
        subtitle: "Fiber · CO₂ · Marking",
        count: "60+ machines",
    },
    {
        icon: CircuitBoard,
        title: "PCB Prototyping",
        subtitle: "SMT · LPKF · Reflow",
        count: "45+ machines",
    },
    {
        icon: Bot,
        title: "Robotics",
        subtitle: "6-Axis · Cobots · Grippers",
        count: "35+ systems",
    },
    {
        icon: Layers,
        title: "Injection Moulding",
        subtitle: "80T – 250T · Multi-shot",
        count: "40+ presses",
    },
];

export default function MachineCategories() {
    return (
        <section className="py-24 bg-gradient-to-b from-slate-50 via-white to-indigo-50">
            <div className="max-w-7xl mx-auto px-6">

                {/* Badge */}
                {/* Badge */}
                <div className="flex justify-center mb-5">
                    <span className="px-4 py-1.5 rounded-full border border-indigo-200 bg-white text-xs font-semibold text-indigo-600 shadow-sm">
                        Machines & Equipment
                    </span>
                </div>

                {/* Heading */}
                <div className="text-center max-w-3xl mx-auto">
                    <h2 className="text-4xl md:text-5xl font-bold text-slate-900 leading-tight">
                        Every process,
                        <span className="text-indigo-600"> one platform</span>
                    </h2>

                    <p className="mt-4 text-lg text-slate-500 leading-8">
                        From additive manufacturing to precision CNC, PCB fabrication and robotics —
                        access industrial-grade machines across Andhra Pradesh.
                    </p>
                </div>

                {/* Cards */}
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
                    {machines.map((item) => {
                        const Icon = item.icon;

                        return (
                            <div
                                key={item.title}
                                className="group rounded-2xl border border-slate-200 bg-white p-5 shadow-sm hover:shadow-lg hover:border-indigo-200 transition-all duration-300"
                            >
                                <div className="flex items-center gap-4">

                                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-indigo-600 to-blue-500 shadow-sm group-hover:scale-105 transition-transform">
                                        <Icon className="text-white" size={22} />
                                    </div>

                                    <div className="flex-1">
                                        <h3 className="text-xl font-semibold text-slate-900">
                                            {item.title}
                                        </h3>

                                        <p className="mt-1 text-sm text-slate-500">
                                            {item.subtitle}
                                        </p>

                                        <p className="mt-2 text-sm font-semibold text-indigo-600">
                                            {item.count}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                {/* Button */}
                <div className="flex justify-center mt-16">
                 

<Link
  to="/machineMarketplace"
  className="inline-flex items-center gap-3 bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-700 hover:to-blue-700 text-white px-8 py-4 rounded-2xl font-semibold shadow-lg transition rounded-2xl"
>
  Browse all machines
  <ArrowRight size={20} />
</Link>
                </div>
            </div>
        </section>
    );
}